import { Indicator } from "@radix-ui/react-radio-group"
import type { ReactElement } from "react"

import { Text } from "../Text"
import styles from "./RadioButton.module.css"
import { RadioItem } from "./RadioItem"

export interface RadioButtonProps {
  label?: string
  disabled?: boolean

  /**
   * Whether this RadioButton is only included for decoration purposes
   * or is the actual Radio Group Item.
   */
  decorative?: boolean
}

export function RadioButton(props: RadioButtonProps) {
  const { label, disabled = false, decorative = false } = props

  function wrapInRadioItem(node: ReactElement) {
    if (decorative) return node
    return <RadioItem disabled={disabled}>{node}</RadioItem>
  }

  return wrapInRadioItem(
    <div className={styles.root}>
      <div className={styles.circle}>
        <Indicator className={styles.indicator}></Indicator>
      </div>
      {label && <Text>{label}</Text>}
    </div>,
  )
}
